import Lottie from 'lottie-react';

import generalNotesTodo from '../jsons/General-Notes-Todo.json';

const GeneralNotesTodo = props => {
  return <Lottie loop={false} animationData={generalNotesTodo} {...props} />;
};

export default GeneralNotesTodo;
